
import React, { useState, useEffect } from 'react';
import './index.less';
import Nav from '@/components/Nav';
import useSWR from 'swr';
import { getDetail } from '@/constants/api';
import moment from 'moment';
import { investigation} from '@/constants/api';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';

const KfTrackDetailIndex = () => {
  
  const [checked, setChecked] = useState(1);
  const [isSolve, setIsSolve] = useState(1);
  const [tips, setTips] = useState('您还可以对该服务进行评论');
  const [textareaVal, setTextareaVal] = useState('');
  const navigate = useNavigate();
  const arr = window.location.search.split('=');
  const id = arr[arr.length - 1];
  const { data } = useSWR(`${getDetail}?workCode=${id}&isWeGame=true`);
  

  useEffect(() => {
    checked === 3 ? setTips('请您填写不满意的原因，这对我们服务质量提升非常重要，谢谢！') : setTips('您还可以对该服务进行评论');
  }, [checked]);

  const evaluate = () => {
    const params = {
      code: id,
      content: textareaVal,
      satisfaction: checked,
      isSolved: isSolve,
      isWeGame: true,
    };

    investigation(params).then(res => {
      if (res.retCode === 'SUCCESS') {
        Modal.success({
          title: '评价成功',
          okText: '确定',
          centered: true,
      });
        navigate('/kf/kfTrackIndex');
      }else {
        Modal.error({
          title: res.message,
          okText: '确定',
          centered: true,
      });
      }
    });
  };

  return (
    <div className='trackDetailBox'>
      <Nav activeMenu="kfCenter"/>
      <div className='trackWarp'>
        <div className='trackContent'>
          <div className='trackContentTable'>
            <h2 className="wgContentTitle">
              <span>详细信息</span>
            </h2>
            <div className='content'>
              <div className='singleItem'>
                <p className='title'>工单状态：</p>
                <p>{data?.data?.stateName}</p>
              </div>
              <div className='singleItem'>
                <p className='title'>提交时间：</p>
                <p>{moment(data?.data?.createTime).format('YYYY年MM月DD日 HH:mm:ss')}</p>
              </div>
              {
                data?.data?.stateName === '已完成' || data?.data?.stateName === '已终止' ? <>
                  <div className='singleItem'>
                  <p className='title'>完成时间：</p>
                  <p>{moment(data?.data?.completeTime).format('YYYY年MM月DD日 HH:mm:ss')}</p>
                </div>
                <div className='singleItem'>
                  <p className='title'>提问账号：</p>
                  <p>{data?.data?.submitAccount}</p>
                </div>
                </>  : <div className='singleItem'>
                  <p className='title'>提问账号：</p>
                  <p>{data?.data?.submitAccount}</p>
                </div>
              }
              <div className='singleItem'>
                <p className='title'>被问账号：</p>
                <p>{data?.data?.askedAccount}</p>
              </div>
              <div className='singleItem'>
                <p className='title'>游戏：</p>
                <p>{data?.data?.gameName}</p>
              </div>
              <div className='singleItem'>
                <p className='title'>服务器：</p>
                <p>{data?.data?.gameServerName}</p>
              </div>
              <div className='singleItem'>
                <p className='title'>角色名称：</p>
                <p>{data?.data?.role}</p>
              </div>
              <div className='singleItem'>
                <p className='title'>情况说明：</p>
                <p className='text'>{data?.data?.note}</p>
              </div>
              <div className='singleItem'>
                <p className='title'>回复内容：</p>
                <p className='text'>{data?.data?.replyContent}</p>
              </div>
            </div>
            {
              data?.data?.investigationFlag ? <>
                <h2 className="wgContentTitle marginTop">
                  <span>服务评价</span>
                </h2>
                <div>
                  <div className='serviceBox'>
                    <div className='serviceItem'>
                      <p className='serviceItemTitle'>服务评价：</p>
                      <div>
                        <input className='radio' type="radio" onChange={() => setChecked(1)} checked={checked === 1} /><label>满意</label>
                        <input className='radio' type="radio" onChange={() => setChecked(2)} checked={checked === 2} /><label>一般</label>
                        <input className='radio' type="radio" onChange={() => setChecked(3)} checked={checked === 3} /><label>不满意</label>
                      </div>
                    </div>
                    <div className='serviceItem'>
                      <p className='serviceItemTitle'>问题解决：</p>
                      <div>
                        <input className='radio' type="radio" onChange={() => setIsSolve(1)} checked={isSolve === 1} /><label>是</label>
                        <input className='radio' type="radio" onChange={() => setIsSolve(0)} checked={isSolve === 0} /><label>否</label>
                      </div>
                    </div>
                    <textarea className='textarea' maxLength={100} placeholder='提醒：请不要在此处填写您的账号、密码、验证码等敏感信息，内容长度限制100汉字' 
                      value={textareaVal} onChange={(e) => setTextareaVal(e.target.value)}></textarea>
                    <p className='paragraph'>{tips}<span style={{ color: '#c00' }}>&lt;选填&gt;</span></p>
                  </div>
                  <div className='btns'>
                      <div className='evaluate' onClick={() => evaluate()}>评价</div>
                      <div className='goBack' onClick={() => navigate('/kf/kfTrackIndex')}>返回</div>
                  </div>
                </div>
              </> : null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default KfTrackDetailIndex;
